import { writable } from 'svelte/store';

/** Untertitel für Geräusche (nur sichtbar, wenn in den Einstellungen aktiviert) */
export const captions = writable<{ id: number; text: string }[]>([]);
let n = 0;
export function showCaption(text: string) {
  const id = ++n;
  captions.update((c) => [...c.slice(-2), { id, text }]);
  setTimeout(() => captions.update((c) => c.filter((x) => x.id !== id)), 2600);
}
